import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
  title: {
    id: 'purchaseDashboard.activities.title',
    defaultMessage: 'Group activity',
  },
  memberWithdrewTitle: {
    id: 'dashboard.activities.memberWithdrew.title',
    defaultMessage: 'Contributor withdrew',
  },
  memberWithdrewDescription: {
    id: 'dashboard.activities.memberWithdrew.description',
    defaultMessage: '{fullName} has left the group',
  },

  purchaseClaimedTitle: {
    id: 'dashboard.activities.purchaseClaimed.title',
    defaultMessage: 'Group created',
  },
  purchaseClaimedDescription: {
    id: 'dashboard.activities.purchaseClaimed.description',
    defaultMessage: '{fullName} created the group',
  },

  purchaseTippedTitle: {
    id: 'dashboard.activities.purchaseTipped.title',
    defaultMessage: 'Your group did it!',
  },

  purchaseTippedDescription: {
    id: 'dashboard.activities.purchaseTipped.description',
    defaultMessage: 'Enough people commited to the minimum slots required to make the purchase',
  },

  purchaseTippedDescriptionMulti: {
    id: 'dashboard.activities.purchaseTipped.descriptionMulti',
    defaultMessage: "Enough people commited to the minimum slots required to send the group's payment",
  },

  purchaseTippedDescriptionSPPSingle: {
    id: 'dashboard.activities.purchaseTipped.descriptionSPPSingle',
    defaultMessage: 'Enough contributions were made to make the purchase!',
  },
  purchaseTippedDescriptionSPPMulti: {
    id: 'dashboard.activities.purchaseTipped.descriptionSPPMulti',
    defaultMessage: "Enouth contributions were made to send the group's payment!",
  },

  purchaseCompletedTitle: {
    id: 'dashboard.activities.purchaseCompleted.title',
    defaultMessage: 'Purchase complete!',
  },

  purchaseUntippedTitle: {
    id: 'dashboard.activities.purchaseUntipped.title',
    defaultMessage: 'Contributors needed',
  },
  purchaseUntippedDescription: {
    id: 'dashboard.activities.purchaseUntipped.description',
    defaultMessage: 'You need more contributors to tip the group again',
  },
  paymentCapturedTitle: {
    id: 'dashboard.activities.paymentCaptured.title',
    defaultMessage: 'Payment succesful!',
  },
  paymentCapturedDescription: {
    id: 'dashboard.activities.paymentCaptured.description',
    defaultMessage: "Payment {paymentNumber} of {totalOfPayments} for {paymentAmount} was successfully paid to {merchantDisplayName}",
  },
  paymentCapturedDescriptionDeposit: {
    id: 'dashboard.activities.paymentCaptured.descriptionDeposit',
    defaultMessage: "The deposit (Payment 1 of {totalOfPayments} for {paymentAmount}) was successfully paid to {merchantDisplayName}",
  },
  paymentCapturedDescriptionSingle: {
    id: 'dashboard.activities.paymentCaptured.descriptionSingle',
    defaultMessage: "Your group's payment of {paymentAmount} was successfully paid to {merchantDisplayName} to finalize your purchase!",
  },
  paymentCapturedDescriptionMulti: {
    id: 'dashboard.activities.paymentCaptured.descriptionMulti',
    defaultMessage: "Your group's final payment of {paymentAmount} was successfully paid to {merchantDisplayName} to finalize your purchase!",
  },

  depositAuthorizedTitle: {
    id: 'dashboard.activities.depositAuthorized.title',
    defaultMessage: 'Deposit pending',
  },
  depositAuthorizedDescription: {
    id: 'dashboard.activities.depositAuthorized.description',
    defaultMessage: "{fullName}’s deposit to secure the inventory awaits acceptance by {merchantDisplayName}",
  },

  regularPaymentAuthorizedTitle: {
    id: 'dashboard.activities.regularPaymentAuthorized.title',
    defaultMessage: 'Payment pending',
  },
  regularPaymentAuthorizedDescription: {
    id: 'dashboard.activities.regularPaymentAuthorized.description',
    defaultMessage: "The group’s payment number {paymentNumber} of {totalOfPayments} for {paymentAmount} awaits acceptance by {merchantDisplayName}",
  },

  lastPaymentAuthorizedTitle: {
    id: 'dashboard.activities.lastPaymentAuthorized.title',
    defaultMessage: 'Purchase pending',
  },
  lastPaymentAuthorizedDescription: {
    id: 'dashboard.activities.lastPaymentAuthorized.description',
    defaultMessage: "The group’s payment has been submitted and awaits acceptance by {merchantDisplayName} to finalize the purchase",
  },

  memberJoinedTitle: {
    id: 'dashboard.activities.memberJoined.title',
    defaultMessage: 'New contributor!',
  },
  memberJoinedDescription: {
    id: 'dashboard.activities.memberJoined.description',
    defaultMessage: "{fullName} joined the group",
  },

  memberInvitedTitle: {
    id: 'dashboard.activities.memberInvited.title',
    defaultMessage: 'Invites sent',
  },
  memberInvitedDescription: {
    id: 'dashboard.activities.memberInvited.description',
    defaultMessage: "{fullName} invited a new contributor",
  },
  memberInvitedDescriptionSeveral: {
    id: 'dashboard.activities.memberInvited.descriptionSeveral',
    defaultMessage: "{fullName} invited {invited} new contributors",
  },

  purchaseUpdatedTitle: {
    id: 'dashboard.activities.purchaseUpdated.title',
    defaultMessage: 'Group edited',
  },
  purchaseUpdatedDescriptionNoValue: {
    id: 'dashboard.activities.purchaseUpdated.descriptionNoValue',
    defaultMessage: "{fullName} changed the {attribute}",
  },
  purchaseUpdatedDescriptionNoValueSpecial: {
    id: 'dashboard.activities.purchaseUpdated.descriptionNoValueSpecial',
    defaultMessage: "{fullName} changed the {attribute} by removing it",
  },
  purchaseUpdatedDescription: {
    id: 'dashboard.activities.purchaseUpdated.description',
    defaultMessage: "{fullName} changed the {attribute} to {value}",
  },

  purchaseUpdatedProductCostsDescription: {
    id: 'dashboard.activities.purchaseUpdated.productCostsDescription',
    defaultMessage: "{fullName} changed the cost structure to:",
  },

  purchaseUpdatedProductCosts: {
    id: 'dashboard.activities.purchaseUpdated.productCosts',
    defaultMessage: "{minSlots} - {maxSlots} {slotsName}: {amount}",
  },

  purchaseUpdatedProductCosts_adult: {
    id: 'dashboard.activities.purchaseUpdated.productCosts_adult',
    defaultMessage: "{minSlots} - {maxSlots} adults: {amount}",
  },
  purchaseUpdatedProductCosts_passenger: {
    id: 'dashboard.activities.purchaseUpdated.productCosts_passenger',
    defaultMessage: "{minSlots} - {maxSlots} passengers: {amount}",
  },
  purchaseUpdatedProductCosts_ticket: {
    id: 'dashboard.activities.purchaseUpdated.productCosts_ticket',
    defaultMessage: "{minSlots} - {maxSlots} tickets: {amount}",
  },
  purchaseUpdatedProductCosts_seat: {
    id: 'dashboard.activities.purchaseUpdated.productCosts_seat',
    defaultMessage: "{minSlots} - {maxSlots} seats: {amount}",
  },
  purchaseUpdatedProductCosts_item: {
    id: 'dashboard.activities.purchaseUpdated.productCosts_item',
    defaultMessage: "{minSlots} - {maxSlots} items: {amount}",
  },
  purchaseUpdatedProductCosts_shirt: {
    id: 'dashboard.activities.purchaseUpdated.productCosts_shirt',
    defaultMessage: "{minSlots} - {maxSlots} shirts: {amount}",
  },
  purchaseUpdatedProductCosts_person: {
    id: 'dashboard.activities.purchaseUpdated.productCosts_person',
    defaultMessage: "{minSlots} - {maxSlots} people: {amount}",
  },
  purchaseUpdatedProductCosts_guest: {
    id: 'dashboard.activities.purchaseUpdated.productCosts_guest',
    defaultMessage: "{minSlots} - {maxSlots} guests: {amount}",
  },
  purchaseUpdatedProductCosts_player: {
    id: 'dashboard.activities.purchaseUpdated.productCosts_player',
    defaultMessage: "{minSlots} - {maxSlots} players: {amount}",
  },
  purchaseUpdatedProductCosts_student: {
    id: 'dashboard.activities.purchaseUpdated.productCosts_student',
    defaultMessage: "{minSlots} - {maxSlots} students: {amount}",
  },

  purchaseUpdatedProductCostsNoMaxSlots: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots',
    defaultMessage: "{minSlots}+ {slotsName}: {amount}",
  },
  purchaseUpdatedProductCostsNoMaxSlots_adult: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots_adult',
    defaultMessage: "{minSlots}+ adults: {amount}",
  },
  purchaseUpdatedProductCostsNoMaxSlots_passenger: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots_passenger',
    defaultMessage: "{minSlots}+ passengers: {amount}",
  },
  purchaseUpdatedProductCostsNoMaxSlots_ticket: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots_ticket',
    defaultMessage: "{minSlots}+ tickets: {amount}",
  },
  purchaseUpdatedProductCostsNoMaxSlots_seat: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots_seat',
    defaultMessage: "{minSlots}+ seats: {amount}",
  },
  purchaseUpdatedProductCostsNoMaxSlots_item: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots_item',
    defaultMessage: "{minSlots}+ items: {amount}",
  },
  purchaseUpdatedProductCostsNoMaxSlots_shirt: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots_shirt',
    defaultMessage: "{minSlots}+ shirts: {amount}",
  },
  purchaseUpdatedProductCostsNoMaxSlots_person: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots_person',
    defaultMessage: "{minSlots}+ people: {amount}",
  },
  purchaseUpdatedProductCostsNoMaxSlots_guest: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots_guest',
    defaultMessage: "{minSlots}+ guests: {amount}",
  },
  purchaseUpdatedProductCostsNoMaxSlots_player: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots_player',
    defaultMessage: "{minSlots}+ players: {amount}",
  },
  purchaseUpdatedProductCostsNoMaxSlots_student: {
    id: 'dashboard.activities.purchaseUpdated.productCostsNoMaxSlots_student',
    defaultMessage: "{minSlots}+ students: {amount}",
  },

  purchaseUpdatedSinglePaymentNoDueDeadlineSingle: {
    id: 'dashboard.activities.purchaseUpdated.singlePaymentNoDueDeadlineSingle',
    defaultMessage: "{fullName} changed the deadline by removing it",
  },

  purchaseUpdatedSinglePaymentNoDueDeadlineMulti: {
    id: 'dashboard.activities.purchaseUpdated.singlePaymentNoDueDeadlineMulti',
    defaultMessage: "The deadline by removing it",
  },

  purchaseUpdatedDescriptionTotalCost: {
    id: "dashboard.activities.purchaseUpdated.totalCost",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} {slotsName}",
  },
  purchaseUpdatedDescriptionTotalCost_adult: {
    id: "dashboard.activities.purchaseUpdated.totalCost_adult",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} adults",
  },
  purchaseUpdatedDescriptionTotalCost_passenger: {
    id: "dashboard.activities.purchaseUpdated.totalCost_passenger",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} passengers",
  },
  purchaseUpdatedDescriptionTotalCost_ticket: {
    id: "dashboard.activities.purchaseUpdated.totalCost_ticket",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} tickets",
  },
  purchaseUpdatedDescriptionTotalCost_seat: {
    id: "dashboard.activities.purchaseUpdated.totalCost_seat",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} seats",
  },
  purchaseUpdatedDescriptionTotalCost_item: {
    id: "dashboard.activities.purchaseUpdated.totalCost_item",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} items",
  },
  purchaseUpdatedDescriptionTotalCost_shirt: {
    id: "dashboard.activities.purchaseUpdated.totalCost_shirt'",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} shirts",
  },
  purchaseUpdatedDescriptionTotalCost_person: {
    id: "dashboard.activities.purchaseUpdated.totalCost_person'",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} people",
  },
  purchaseUpdatedDescriptionTotalCost_guest: {
    id: "dashboard.activities.purchaseUpdated.totalCost_guest",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} guests",
  },
  purchaseUpdatedDescriptionTotalCost_player: {
    id: "dashboard.activities.purchaseUpdated.totalCost_player",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} players",
  },
  purchaseUpdatedDescriptionTotalCost_student: {
    id: "dashboard.activities.purchaseUpdated.totalCost_student",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} students",
  },

  purchaseUpdatedDescriptionTotalCostNoMax: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} or more {slotsName}",
  },
  purchaseUpdatedDescriptionTotalCostNoMax_adult: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax_adult",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} or more adults",
  },
  purchaseUpdatedDescriptionTotalCostNoMax_passenger: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax_passenger",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} or more passengers",
  },
  purchaseUpdatedDescriptionTotalCostNoMax_ticket: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax_ticket",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} or more tickets",
  },
  purchaseUpdatedDescriptionTotalCostNoMax_seat: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax_seat",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} or more seats",
  },
  purchaseUpdatedDescriptionTotalCostNoMax_item: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax_item",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} or more items",
  },
  purchaseUpdatedDescriptionTotalCostNoMax_shirt: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax_shirt'",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} or more shirts",
  },
  purchaseUpdatedDescriptionTotalCostNoMax_person: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax_person'",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} or more people",
  },
  purchaseUpdatedDescriptionTotalCostNoMax_guest: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax_guest",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} or more guests",
  },
  purchaseUpdatedDescriptionTotalCostNoMax_player: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax_player",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} to {maxSlots} players",
  },
  purchaseUpdatedDescriptionTotalCostNoMax_student: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMax_student",
    defaultMessage: "{fullName} changed the {attribute} to {amount} for {minSlots} or more students",
  },

  purchaseUpdatedDescriptionTotalCostMulti: {
    id: "dashboard.activities.purchaseUpdatedMulti.totalCost",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} {slotsName}",
  },
  purchaseUpdatedDescriptionTotalCostMulti_adult: {
    id: "dashboard.activities.purchaseUpdated.totalCostMulti_adult",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} adults",
  },
  purchaseUpdatedDescriptionTotalCostMulti_passenger: {
    id: "dashboard.activities.purchaseUpdated.totalCostMulti_passenger",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} passengers",
  },
  purchaseUpdatedDescriptionTotalCostMulti_ticket: {
    id: "dashboard.activities.purchaseUpdated.totalCostMulti_ticket",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} tickets",
  },
  purchaseUpdatedDescriptionTotalCostMulti_seat: {
    id: "dashboard.activities.purchaseUpdated.totalCostMulti_seat",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} tickets",
  },
  purchaseUpdatedDescriptionTotalCostMulti_item: {
    id: "dashboard.activities.purchaseUpdated.totalCostMulti_item",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} items",
  },
  purchaseUpdatedDescriptionTotalCostMulti_shirt: {
    id: "dashboard.activities.purchaseUpdated.totalCostMulti_shirt'",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} shirts",
  },
  purchaseUpdatedDescriptionTotalCostMulti_person: {
    id: "dashboard.activities.purchaseUpdated.totalCostMulti_person'",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} people",
  },
  purchaseUpdatedDescriptionTotalCostMulti_guest: {
    id: "dashboard.activities.purchaseUpdated.totalCostMulti_guest",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} guests",
  },
  purchaseUpdatedDescriptionTotalCostMulti_player: {
    id: "dashboard.activities.purchaseUpdated.totalCostMulti_player",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} players",
  },
  purchaseUpdatedDescriptionTotalCostMulti_student: {
    id: "dashboard.activities.purchaseUpdated.totalCostMulti_student",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} students",
  },

  purchaseUpdatedDescriptionTotalCostNoMaxMulti: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMulti",
    defaultMessage: "The {attribute} to {amount} for {minSlots} or more {slotsName}",
  },
  purchaseUpdatedDescriptionTotalCostNoMaxMulti_adult: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMulti_adult",
    defaultMessage: "The {attribute} to {amount} for {minSlots} or more adults",
  },
  purchaseUpdatedDescriptionTotalCostNoMaxMulti_passenger: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMulti_passenger",
    defaultMessage: "The {attribute} to {amount} for {minSlots} or more passengers",
  },
  purchaseUpdatedDescriptionTotalCostNoMaxMulti_ticket: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMulti_ticket",
    defaultMessage: "The {attribute} to {amount} for {minSlots} or more tickets",
  },
  purchaseUpdatedDescriptionTotalCostNoMaxMulti_seat: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMulti_seat",
    defaultMessage: "The {attribute} to {amount} for {minSlots} or more seats",
  },
  purchaseUpdatedDescriptionTotalCostNoMaxMulti_item: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMutli_item",
    defaultMessage: "The {attribute} to {amount} for {minSlots} or more items",
  },
  purchaseUpdatedDescriptionTotalCostNoMaxMulti_shirt: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMulti_shirt'",
    defaultMessage: "The {attribute} to {amount} for {minSlots} or more shirts",
  },
  purchaseUpdatedDescriptionTotalCostNoMaxMulti_person: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMulti_person'",
    defaultMessage: "The {attribute} to {amount} for {minSlots} or more people",
  },
  purchaseUpdatedDescriptionTotalCostNoMaxMulti_guest: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMulti_guest",
    defaultMessage: "The {attribute} to {amount} for {minSlots} or more guests",
  },
  purchaseUpdatedDescriptionTotalCostNoMaxMulti_player: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMulti_player",
    defaultMessage: "The {attribute} to {amount} for {minSlots} to {maxSlots} players",
  },
  purchaseUpdatedDescriptionTotalCostNoMaxMulti_student: {
    id: "dashboard.activities.purchaseUpdated.totalCostNoMaxMulti_student",
    defaultMessage: "The {attribute} to {amount} for {minSlots} or more students",
  },


  purchaseUpdatedPayment: {
    id: 'dashboard.activities.purchaseUpdated.payment',
    defaultMessage: "Payment {number}: {percentage}% due {date}",
  },
  purchaseUpdatedPaymentNoDuedeadline: {
    id: 'dashboard.activities.purchaseUpdated.paymentNoDuedeadline',
    defaultMessage: "Payment {number}: {percentage}%",
  },
  purchaseUpdatedPaymentDescription: {
    id: 'dashboard.activities.purchaseUpdated.paymentDescription',
    defaultMessage: "{fullName} changed the payment schedule to:",
  },

  purchaseUpdatedDescriptionMultiTitle: {
    id: 'dashboard.activities.purchaseUpdated.descriptionMultiTitle',
    defaultMessage: "{fullName} changed the following:",
  },

  purchaseUpdatedDescriptionNoValueMulti: {
    id: 'dashboard.activities.purchaseUpdated.descriptionNoValueMulti',
    defaultMessage: "The {attribute}",
  },
  purchaseUpdatedDescriptionNoValueMultiSpecial: {
    id: 'dashboard.activities.purchaseUpdated.descriptionNoValueMultiSpecial',
    defaultMessage: "The {attribute} by removing it",
  },
  purchaseUpdatedDescriptionMulti: {
    id: 'dashboard.activities.purchaseUpdated.descriptionMulti',
    defaultMessage: "The {attribute} to {value}",
  },
  purchaseUpdatedProductCostsDescriptionMulti: {
    id: 'dashboard.activities.purchaseUpdated.productCostsDescriptionMulti',
    defaultMessage: "The cost structure to:",
  },
  purchaseUpdatedPaymentDescriptionMulti: {
    id: 'dashboard.activities.purchaseUpdated.paymentDescriptionMulti',
    defaultMessage: "The payment schedule to:",
  },


  // Attribute names
  productName: {
    id: 'dashboard.activities.productName',
    defaultMessage: 'name of the purchase',
  },
  productDescription: {
    id: 'dashboard.activities.productDescription',
    defaultMessage: 'purchase description',
  },
  productInventoryId: {
    id: 'dashboard.activities.productInventoryId',
    defaultMessage: 'purchase inventory ID',
  },
  productLink: {
    id: 'dashboard.activities.productLink',
    defaultMessage: 'link to purchase details',
  },
  productIsAvailable: {
    id: 'dashboard.activities.productIsAvailable',
    defaultMessage: 'product is available',
  },
  productStartDatetime: {
    id: 'dashboard.activities.productStartDatetime',
    defaultMessage: 'event start',
  },
  productEndDatetime: {
    id: 'dashboard.activities.productEndDatetime',
    defaultMessage: 'event end',
  },
  productExternalPurchaseId: {
    id: 'dashboard.activities.productExternalPurchaseId',
    defaultMessage: 'product external purchase ID',
  },
  productCostType: {
    id: 'dashboard.activities.productCostType',
    defaultMessage: 'product cost type',
  },
  productAllowedSplitTypes: {
    id: 'dashboard.activities.productAllowedSplitTypes',
    defaultMessage: 'product allowed split types',
  },
  groupSplitType: {
    id: 'dashboard.activities.groupSplitType',
    defaultMessage: 'group split',
  },
  groupMinContribution: {
    id: 'dashboard.activities.groupMinContribution',
    defaultMessage: 'minimum contribution',
  },
  groupMinSlots: {
    id: 'dashboard.activities.groupMinSlots',
    defaultMessage: 'minimum group size',
  },
  groupMaxSlots: {
    id: 'dashboard.activities.groupMaxSlots',
    defaultMessage: 'maximum group size',
  },
  groupOrganizerFullName: {
    id: 'dashboard.activities.groupOrganizerFullName',
    defaultMessage: 'organizer\'s name',
  },
  groupOrganizerEmail: {
    id: 'dashboard.activities.groupOrganizerEmail',
    defaultMessage: 'organizer\'s email',
  },
  cancellationReason: {
    id: 'dashboard.activities.cancellationReason',
    defaultMessage: 'cancellation reason',
  },
  cancelledBy: {
    id: 'dashboard.activities.cancelledBy',
    defaultMessage: 'cancellation reason',
  },
  currencyCode: {
    id: 'dashboard.activities.currencyCode',
    defaultMessage: 'currency code',
  },
  groupCommitDeadlineMannuallyUpdated: {
    id: 'dashboard.activities.groupCommitDeadlineMannuallyUpdated',
    defaultMessage: 'group commit deadline',
  },
  productCosts: {
    id: 'dashboard.activities.productCosts',
    defaultMessage: 'total cost',
  },
  productCostAdded: {
    id: 'dashboard.activities.productCostAdded',
    defaultMessage: 'total cost',
  },
  payments: {
    id: 'dashboard.activities.payments',
    defaultMessage: 'next deadline',
  },

  addCommentLoggedOutBanner: {
    id: 'dashboard.activities.addCommentLoggedOutBanner',
    defaultMessage: 'Showing only group status activity.',
  },

  addCommentLoggedOutCopy: {
    id: 'dashboard.activities.addCommentLoggedOutCopy',
    defaultMessage: 'You need an account to see comments and post to the group',
  },

  createAccount: {
    id: 'dashboard.activities.createAccount',
    defaultMessage: 'Create Account',
  },

  postComment: {
    id: 'dashboard.activities.postComment',
    defaultMessage: 'Post comment',
  },

  addCommentHint: {
    id: 'dashboard.activities.addCommentHint',
    defaultMessage: 'Only logged-in group members see comments.',
  },

  addCommentPlaceholder: {
    id: 'dashboard.activities.addCommentPlaceholder',
    defaultMessage: 'Write comment...',
  },

  addCommentError: {
    id: 'dashboard.activities.addCommentError',
    defaultMessage: "Comment can't be empty.",
  },

  ssp: {
    id: 'dashboard.activities.ssp',
    defaultMessage: 'custom',
  },

  even: {
    id: 'dashboard.activities.even',
    defaultMessage: 'even',
  },

  purchaseUpdatedLinkThisPage: {
    id: 'dashboard.activities.purchaseUpdatedLinkThisPage',
    defaultMessage: "this page",
  },
  purchaseUpdatedLinkMultiNoValue: {
    id: 'dashboard.activities.purchaseUpdatedLinkMultiNoValue',
    defaultMessage: "The {attribute} by removing it ",
  },
  purchaseUpdatedLinkMulti: {
    id: 'dashboard.activities.purchaseUpdatedLinkMulti',
    defaultMessage: "The {attribute} to ",
  },

  purchaseUpdatedLinkNoValue: {
    id: 'dashboard.activities.purchaseUpdatedLinkNoValue',
    defaultMessage: "{fullName} removed the {attribute}",
  },

  purchaseUpdatedLink: {
    id: 'dashboard.activities.purchaseUpdatedLink',
    defaultMessage: "{fullName} changed the {attribute} to",
  },
});



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/activities.i18n.js